import SelectOption from "./SelectOption.js";
import withValidation from "./withValidation.js";

export default withValidation(SelectOption);
